import { aodDeficiencyBreachedWorkflow } from '@app/modules/audit/modules/aod/notifications/aod-deficiency-breached.workflow';
import { evidenceExportCompletedWorkflow } from '@app/modules/audit/modules/reports/notifications/evidence-export-completed.workflow';
import { socialUploadCompletedWorkflow } from '@app/modules/social-export/notifications/social-upload-completed.workflow';
import { socialUploadFailedWorkflow } from '@app/modules/social-export/notifications/social-upload-failed.workflow';
import { groupNotificationWorkflowsByCategory } from './group-notification-workflows-by-category';
import { NotificationWorkflow } from './notification-workflow';
import {
  NOTIFICATION_WORKFLOW_CATEGORIES,
  NOTIFICATION_WORKFLOW_CATEGORY_ORDER,
  isNotificationWorkflowCategory,
  notificationWorkflowCategoryMessages,
} from './notification-workflow-category';

/**
 * All Knock workflows registered for the in-app feed and preferences.
 * Import feature descriptors by path (no feature barrels) to avoid cycles.
 * Every entry must declare a known `category` (see notification-workflow-category.ts).
 */
export const notificationWorkflows: readonly NotificationWorkflow[] = [
  aodDeficiencyBreachedWorkflow,
  evidenceExportCompletedWorkflow,
  socialUploadCompletedWorkflow,
  socialUploadFailedWorkflow,
];

const workflowsByKey = new Map(
  notificationWorkflows.map((workflow) => [workflow.key, workflow] as const),
);

/**
 * Looks up a registered workflow by Knock workflow key.
 */
export function getNotificationWorkflow(key: string | undefined): NotificationWorkflow | undefined {
  if (!key) {
    return undefined;
  }
  return workflowsByKey.get(key as NotificationWorkflow['key']);
}

export type { NotificationWorkflowCategoryGroup } from './group-notification-workflows-by-category';
export type {
  NotificationEnvelopeForKey,
  NotificationWorkflow,
  NotificationWorkflowChannels,
  NotificationWorkflowData,
  NotificationWorkflowKey,
} from './notification-workflow';
export type { NotificationWorkflowCategory } from './notification-workflow-category';
export {
  NOTIFICATION_WORKFLOW_CATEGORIES,
  NOTIFICATION_WORKFLOW_CATEGORY_ORDER,
  groupNotificationWorkflowsByCategory,
  isNotificationWorkflowCategory,
  notificationWorkflowCategoryMessages,
};
